module.exports = __webpack_public_path__ + "img/5.69284e80.png";